import { RouteObject } from "react-router-dom";
import { DevelopmentScopeTemplatePage } from "src/routes/developments/templates/DevelopmentScopeTemplatePage";
import { DevelopmentScopeTemplatesPage } from "src/routes/developments/templates/DevelopmentScopeTemplatesPage";
import { ScopeTemplateCostCalculatorPage } from "src/routes/developments/templates/ScopeTemplateCostCalculatorPage";
import * as templatesPaths from "src/routing/domains/developments/templates/templatesPaths";

/**
 * SideNav leaf routes for development scope-templates section.
 *
 * Role: data router domain leaves. Spread under `DevelopmentSideNavLayout` in `detail/developmentDetail.ts`.
 */
export const templatesSideNavRoutes: RouteObject[] = [
  { path: templatesPaths.developmentScopeTemplateCostReportRoute.path, Component: ScopeTemplateCostCalculatorPage },
  { path: templatesPaths.developmentScopeTemplateRoute.path, Component: DevelopmentScopeTemplatePage },
  { path: templatesPaths.developmentScopeTemplatesRoute.path, Component: DevelopmentScopeTemplatesPage },
];
